<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="mt-3">
        <div class="mt-3">
          <label class="txt-right required">Tên gói</label>
          <!-- <div class="p-col"> -->
          <InputText
            v-model="name"
            class="text-box input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="name" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Thời hạn</label>
          <!-- <div class="p-col"> -->
          <div class="p-inputgroup text-box">
            <InputNumber
              v-model="value"
              class="input-text-box"
              placeholder="Nhập (Ngày)"
              suffix=" ngày"/>
          </div>
          <input class="input_tmp_validator" id="value" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Phí</label>
          <!-- <div class="p-col"> -->
          <div class="p-inputgroup text-box">
            <InputNumber
              v-model="fee"
              class="input-text-box"
              placeholder="Nhập (đ)"
              suffix=" đ"/>
          </div>
          <input class="input_tmp_validator" id="fee" />
          <!-- </div> -->
        </div>
        <div class="mt-3">
          <label class="txt-right required">Thứ tự</label>
          <div class="text-box">
            <InputNumber
              v-model="ordinal"
              class="text-box input-text-box"
              placeholder="Nhập"
            />
            <input class="input_tmp_validator" id="ordinal" />
          </div>
        </div>
        <div class="mt-3">
          <h4>MÔ TẢ GÓI</h4>
          <packageDescriptions :key="componentKey" v-model="descriptions"/>
        </div>
        <div class="mt-3">
          <Checkbox v-model="active" :binary="true" />Hiển thị
        </div>
      </div>

      <Toolbar class="fixed-bottom-toolbar">
        <template slot="right">
          <Button
            :label="$constants.TEXT_BUTTON.BACK"
            @click="backToList()"
            class="p-button-warning return-style-button" />
          <Button
            v-if="mode == 'edit'"
            :label="$constants.TEXT_BUTTON.EDIT"
            @click="saveData()"
            class="p-button-success main-style-button" />
          <Button
            v-else
            :label="$constants.TEXT_BUTTON.ADD"
            @click="saveData()"
            class="p-button-success main-style-button" />
        </template>
      </Toolbar>
    </div>
  </form>
</template>

<script>
import packageDescriptions from "./components/packageDescriptions";
import ApiRepository from "@/core/ApiRepository";
// import DataServices from "@/core/DataServices";
// import { HotModuleReplacementPlugin } from "webpack";
// import gql from "graphql-tag";
export default {
  components: {
    packageDescriptions
  },
  props: {
    mode: String,
    model: Object,
    users: Array,
  },
  data() {
    return {
      name: null,
      fee: null,
      value: null,
      ordinal: null,
      active: true,
      componentKey: 0,
      descriptions: []
    };
  },
  async mounted() {
    if (this.model !== undefined && Object.keys(this.model).length > 0) {
      this.name = this.model.name;
      this.fee = this.model.fee;
      this.value = this.model.value;
      this.ordinal = this.model.ordinal;
      this.active = this.model.active;
      this.descriptions = this.model.descriptions;
      this.componentKey++;
    } else {
      this.descriptions.push({
          description: "",
          ordinal: 1
      });
    }
  },
  methods: {
    backToList() {
      this.$emit("back");
    },
    async validateData() {
      this.validationErrors = {};

      let name_add = document.getElementById("name");
      if (
        this.name == undefined ||
        this.name == null ||
        this.name == ""
      ) {
        name_add.setCustomValidity("Tên gói không được để trống!");
      } else if (this.name.length > 100) {
        name_add.setCustomValidity("Tên gói không được quá 100 ký tự!");
      } else {
        name_add.setCustomValidity("");
      }

      let value_add = document.getElementById("value");
      if (
        this.value == undefined ||
        this.value == null ||
        this.value == "" ||
        this.value == 0
      ) {
        value_add.setCustomValidity("Thời hạn không được để trống!");
      } else if(await this.existValuePackage()) {
        value_add.setCustomValidity(`Thời hạn ${this.value} ngày bị trùng với gói khác!`);
      } else {
        if (this.value < 0) {
          value_add.setCustomValidity("Vui lòng nhập số nguyên dương > 0");
        } else {
          value_add.setCustomValidity("");
        }
      }

      let fee_add = document.getElementById("fee");
      if (
        this.fee == undefined ||
        this.fee == null ||
        this.fee == "" ||
        this.fee == 0
      ) {
        fee_add.setCustomValidity("Chi phí không được để trống!");
      } else {
        if (this.fee < 0) {
          fee_add.setCustomValidity("Vui lòng nhập số nguyên dương > 0");
        } else {
          fee_add.setCustomValidity("");
        }
      }

      let ordinal_add = document.getElementById("ordinal");
      if (
        (this.ordinal == undefined ||
        this.ordinal == null ||
        this.ordinal == "") && this.ordinal != 0
      ) {
        ordinal_add.setCustomValidity("Thứ tự không được để trống!");
      } else {
        if (this.ordinal < 0) {
          ordinal_add.setCustomValidity("Vui lòng nhập số nguyên dương >= 0");
        } else {
          ordinal_add.setCustomValidity("");
        }
      }

      var inpObj = document.getElementById("frm_action");
      if (!inpObj.checkValidity()) {
        inpObj.reportValidity();
        return true;
      }
    },
    async existValuePackage() {
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        var {data} = await ApiRepository.post("/_api/packages/check_value_exist", {value: this.value, id: this.$route?.params?.id ?? null}, {headers});
        var user = data.data;
        if (user.length > 0) {
          return true;
        }
        return false
      }
    },
    async saveData() {
      this.$commonFuction.is_loading(true);
      if (await this.validateData()) {
        this.$commonFuction.is_loading(false);
        return;
      }
      if (Object.entries(this.validationErrors).length !== 0) {
        this.$commonFuction.is_loading(false);
      }

      var params = {
        name: this.name,
        fee: this.fee,
        value: this.value,
        ordinal: this.ordinal,
        active: this.active,
        descriptions: this.descriptions
      };
      console.log("saveData", params);
      this.$emit("save", params);
      // }
    },
  }
};
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
</style>
